// extracted by mini-css-extract-plugin
export default {"ctn":"Sec_ctn__X2r9i","wrapper":"Sec_wrapper__7w+QO","left":"Sec_left__weVF6","right":"Sec_right__gO8x-"};